<template>
  <v-container>
    <v-row align="center">
      <v-col md="5" offset-md="4">
        <v-card class="card" color="primary">
          <v-card-title class="justify-center font-weight-bold">Asignación de arma a personal</v-card-title>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="4" align="center">
                  <v-progress-circular
                    :value="activeStep * 25"
                    size="96"
                    width="12"
                    color="secondary"
                    rotate="-90"
                  ></v-progress-circular>
                </v-col>
                <v-col cols="8">
                  <div class="text-caption">
                    PASO {{ activeStep }}
                    <div v-if="activeStep == FORM_STEPS.OFICIO" class="d-inline">(Opcional)</div>
                  </div>
                  <div class="text-subtitle-1 font-weight-bold">{{ activeStepTitle }}</div>
                  <a
                    class="text-decoration-none"
                    v-show="activeStep !== FORM_STEPS.BUSQUEDA_PERSONAL"
                    @click="activeStep--"
                    >Volver al paso anterior</a
                  >
                </v-col>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <transition-group name="fade" mode="out-in">
                  <v-col md="12" v-if="activeStep === FORM_STEPS.BUSQUEDA_PERSONAL" key="1">
                    <v-row>
                      <v-col cols="8">
                        <BaseInput
                          v-model="busquedaPersonal.CUIP"
                          label="Buscar personal por CUIP"
                          rounded
                          filled
                          background-color="primary"
                          color="secondary"
                          :disabled="loadingBusqueda"
                        />
                      </v-col>
                      <v-col cols="4">
                        <v-btn
                          rounded
                          block
                          large
                          color="secondary"
                          @click="triggerSearchPersonal()"
                          :disabled="loadingBusqueda || loading"
                          :loading="loadingBusqueda"
                        >
                          Buscar <v-icon class="ml-2">mdi-magnify</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <PersonalList
                          :personal="personal"
                          @select="(personal) => setPersonalArma(personal.idPersonal, personal.portacionArma)"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col md="12" v-if="activeStep === FORM_STEPS.FECHA_ASIGNACION" key="2">
                    <v-date-picker
                      v-model="armaPersonal.fechaAsignado"
                      locale="es"
                      color="secondary"
                      no-title
                      full-width
                      :max="getMaxDay"
                    ></v-date-picker>
                  </v-col>
                  <v-col md="12" v-if="activeStep === FORM_STEPS.ASIGNACION_ARMA" key="3">
                    <v-row>
                      <v-col v-if="armasPersonal.length > 0" cols="12">
                        <div class="text-subtitle-1">Armas asignadas actualmente</div>
                        <ArmasPersonalList :armasPersonal="armasPersonal" />
                      </v-col>
                      <v-col cols="6">
                        <BaseSelect
                          v-model="tipoArma"
                          v-on:change="selectedWeapon = null"
                          :items="filteredTipoArma"
                          item-value="id"
                          item-text="title"
                        >
                          <template v-slot:label>Tipo de arma <span class="red--text">*</span> </template>
                        </BaseSelect>
                      </v-col>
                      <v-col cols="6">
                        <BaseSelect
                          :items="tipoAsignacion"
                          item-value="id"
                          item-text="title"
                          v-model="armaPersonal.fk_idTipoAsignacion"
                        >
                          <template v-slot:label>Tipo de asignación <span class="red--text">*</span> </template>
                        </BaseSelect>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-model="armaPersonal.fk_idArma"
                          v-on:change="triggerFetchCargadoresByCalibre()"
                          filled
                          rounded
                          dense
                          background-color="primary"
                          color="secondary"
                          :items="filteredWeaponsByType"
                          item-value="idArma"
                          item-text="CatModelo.modelo"
                          :disabled="filteredWeaponsByType.length == 0"
                        >
                          <template v-slot:label>Arma <span class="red--text">*</span> </template>
                          <template v-slot:item="{ item, on, attrs }">
                            <v-list-item v-on="on" v-bind="attrs">
                              <v-list-item-content>
                                <v-list-item-subtitle class="text-caption"
                                  >Matrícula: {{ item.matricula }}</v-list-item-subtitle
                                >
                                <v-list-item-title class="text-subtitle-2 font-weight-black"
                                  >Modelo: {{ item.CatModelo.modelo }}</v-list-item-title
                                >
                                <v-list-item-subtitle class="text-caption"
                                  >Serie: {{ item.serie }}</v-list-item-subtitle
                                >
                                <v-list-item-subtitle class="text-caption"
                                  >Clase: {{ item.CatClase.title }}</v-list-item-subtitle
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <BaseInput
                          label="Cantidad de municiones"
                          type="number"
                          v-model.number="municionesArma.cantidad"
                          autocomplete="off"
                          min="0"
                        ></BaseInput>
                        <BaseTextArea
                          label="Comentarios (Opcional)"
                          v-model="armaPersonal.comentario"
                          rows="4"
                          dense
                          no-resize
                        ></BaseTextArea>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col md="12" v-if="activeStep === FORM_STEPS.OFICIO" key="4">
                    <BaseInput label="Número de oficio de resguardo" v-model="cargadorPersonal.oficio"></BaseInput>
                    <BaseTextArea
                      label="Comentarios"
                      v-model="cargadorPersonal.comentario"
                      rows="4"
                      dense
                      no-resize
                    ></BaseTextArea>
                  </v-col>
                </transition-group>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <v-col md="12" xl="6" offset-xl="3" v-if="activeStep > FORM_STEPS.BUSQUEDA_PERSONAL">
                  <v-btn
                    block
                    color="secondary"
                    @click="activeStepButtonHandler"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    >{{ activeStepButtonLabel }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.card-flat {
  box-shadow: none !important;
  transition: 0.3s;
}
</style>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import TextButton from '../../components/base/TextButton.vue'
import BaseInput from '../../components/base/BaseInput.vue'
import BaseSelect from '../../components/base/BaseSelect.vue'
import BaseTextArea from '../../components/base/BaseTextArea.vue'
import Notificacion from '@src/modules/notificaciones/domain/Notificacion'
import { NotificationFactory, NOTIFICATION_TYPES } from '@src/modules/notificaciones/domain/NotificationFactory'
import PersonalList from './asignacion-arma/PersonalList.vue'
import ArmasPersonalList from './asignacion-arma/ArmasPersonalList.vue'

const FORM_STEPS = {
  BUSQUEDA_PERSONAL: 1,
  FECHA_ASIGNACION: 2,
  ASIGNACION_ARMA: 3,
  OFICIO: 4,
}

export default {
  components: {
    TextButton,
    BaseInput,
    BaseSelect,
    BaseTextArea,
    PersonalList,
    ArmasPersonalList,
  },

  async mounted() {
    await this.fetchTipoAsignacion()
  },

  beforeRouteLeave(to, from, next) {
    this.RESET_BUSQUEDA_PERSONAL()
    next()
  },

  data() {
    return {
      FORM_STEPS,
      activeStep: FORM_STEPS.BUSQUEDA_PERSONAL,
      loading: false,
      cuipForm: false,
      cuip: null,
      successfulCuipSearch: null,
      selectedPersonal: null,
      tipoArma: null,

      armaPersonal: {
        fk_idPersonal: null,
        fk_idArma: null,
        fk_idTipoAsignacion: null,
        fechaAsignado: null,
        comentario: '',
      },

      municionesArma: {
        fk_idArma: 0,
        fk_idCalibre: 0,
        cantidad: 0,
        fechaAsignado: null,
      },

      cargadorPersonal: {
        fk_idPersonal: null,
        fk_idCargador: 0,
        fechaAsignado: null,
        oficio: '',
        comentario: '',
      },

      cuipRules: [(v) => !!v || 'Por favor, ingrese el CUIP.'],

      busquedaPersonal: {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        curp: '',
        CUIP: '',
      },

      loadingBusqueda: false,
      susceptibleTercerArma: false,
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonal',
    }),

    ...mapGetters('arma', {
      weapons: 'getArmas',
    }),

    ...mapGetters('tipoArma', {
      weaponTypes: 'getTipoArmas',
    }),

    ...mapGetters('tipoAsignacionArma', {
      tipoAsignacion: 'getTipoAsignacion',
    }),

    ...mapGetters('armaPersonal', {
      armasPersonal: 'getArmasPersonal',
      idArmaPersonal: 'getIdArmaPersonal',
    }),

    ...mapGetters('cargadores', {
      cargadores: 'getCargadores',
    }),

    getMaxDay: function () {
      return moment().format(this.VUETIFY_DATE_FORMAT)
    },

    filteredArmas: function () {
      return this.weapons.filter((arma) => {
        return arma.fk_idEstatus == 1
      })
    },

    filteredTipoArma: function () {
      if (this.susceptibleTercerArma) {
        return this.weaponTypes
      }

      if (this.armasPersonal.some((arma) => arma.Arma.CatClase.fk_idTipo == 1)) {
        return this.weaponTypes.filter((tipoArma) => {
          return tipoArma.id == 2
        })
      } else if (this.armasPersonal.some((arma) => arma.Arma.CatClase.fk_idTipo == 2)) {
        return this.weaponTypes.filter((tipoArma) => {
          return tipoArma.id == 1
        })
      } else {
        return this.weaponTypes
      }
    },

    activeStepTitle: function () {
      switch (this.activeStep) {
        case 1:
          return 'Elegir personal'
        case 2:
          return 'Fecha de asignación'
        case 3:
          return 'Arma, municiones y cargadores'
        case 4:
          return 'Oficio'
      }
    },

    validActiveStep: function () {
      switch (this.activeStep) {
        case 1:
          // if (this.cuipForm) {
          //     return true
          // } else {
          //     return false
          // }
          return true
        case 2:
          // if (this.weaponAssignmentEntryDate != '') {
          //     return true
          // } else {
          //     return false
          // }
          return true
        case 3:
          // if (this.selectedWeapon) {
          //     return true
          // } else return false
          return true
        case 4:
          // if (this.weaponAssignmentOfficeFile) {
          //     return true
          // } else {
          //     return false
          // }
          return true
      }
    },

    activeStepButtonLabel: function () {
      if (this.activeStep < 4) {
        return 'Siguiente paso'
      } else {
        return 'Registrar arma'
      }
    },

    filteredWeaponsByType: function () {
      return this.filteredArmas.filter((weapon) => {
        return weapon.CatClase?.fk_idTipo == this.tipoArma
      })
    },
  },

  methods: {
    ...mapActions('armaPersonal', ['saveArmaPersonal', 'fetchArmasPersonal']),
    ...mapActions('municionArma', ['saveMunicionArma']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('tipoAsignacionArma', ['fetchTipoAsignacion']),
    ...mapActions('cargadores', ['fetchCargadores']),
    ...mapActions('cargadorPersonal', ['saveCargadorPersonal']),
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),
    ...mapActions('notificaciones', ['createNotification']),

    activeStepButtonHandler: async function () {
      if (this.activeStep === FORM_STEPS.BUSQUEDA_PERSONAL) {
        this.handleFetchArmasPersonal()
      } else if (this.activeStep > FORM_STEPS.BUSQUEDA_PERSONAL && this.activeStep < FORM_STEPS.OFICIO) {
        this.activeStep++
      } else {
        await this.triggerAsignacionArma()
      }
    },

    async triggerAsignacionArma() {
      try {
        this.loading = true

        this.armaPersonal.fechaAsignado = moment(this.armaPersonal.fechaAsignado).format(this.API_DATE_FORMAT)
        this.cargadorPersonal.fechaAsignado = this.armaPersonal.fechaAsignado
        this.municionesArma.fechaAsignado = this.armaPersonal.fechaAsignado
        this.municionesArma.fk_idCalibre = this.filteredArmas.find(
          (arma) => arma.idArma == this.armaPersonal.fk_idArma
        ).fk_idCalibre
        this.cargadorPersonal.fk_idPersonal = this.armaPersonal.fk_idPersonal

        await this.saveArmaPersonal(this.armaPersonal)
        await this.sendNotificacion()
        this.municionesArma.fk_idArma = this.idArmaPersonal
        await this.saveMunicionArma(this.municionesArma)
        this.SET_SNACKBAR_MESSAGE('Arma asignada a personal correctamente.')
        this.RESET_BUSQUEDA_PERSONAL()
        this.$router.push('/armeria/personal_armamento')
      } catch {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al asignar el arma al personal.')
      } finally {
        this.loading = false
      }
    },

    async sendNotificacion() {
      const armaAsignada = this.filteredArmas.find((arma) => arma.idArma == this.armaPersonal.fk_idArma)

      const notification = new NotificationFactory(Notificacion).createNotification(
        NOTIFICATION_TYPES.REGISTRO_MOVIMIENTO_ARMA,
        {
          responsable: Number(localStorage.getItem('idPersonal')),
          afectado: this.armaPersonal.fk_idPersonal,
          marcaArma: armaAsignada.CatModelo?.CatMarca?.title,
          modeloArma: armaAsignada.CatModelo?.modelo,
          matricula: armaAsignada?.matricula,
          noEconomico: armaAsignada?.noEconomico,
          nombrePersonal: this.getFullName(this.personal.find((p) => p.idPersonal == this.armaPersonal.fk_idPersonal)),
        }
      )

      await this.createNotification(notification)
    },

    async triggerFetchCargadoresByCalibre() {
      var arma = this.filteredArmas.filter((arma) => {
        return arma.idArma == this.armaPersonal.fk_idArma
      })
      await this.fetchCargadores(arma[0].fk_idCalibre)
    },

    buscaPersonal() {
      return new Promise(async () => {
        setTimeout(await this.searchPersonal(this.busquedaPersonal), 200)
        this.loadingBusqueda = false
      })
    },

    triggerSearchPersonal() {
      this.loadingBusqueda = true
      if (this.busquedaPersonal.CUIP !== '') {
        this.buscaPersonal()
      } else {
        this.loadingBusqueda = false
        this.RESET_BUSQUEDA_PERSONAL()
      }
    },

    setPersonalArma(id_personal, susceptibleTercerArma) {
      this.susceptibleTercerArma = susceptibleTercerArma
      this.armaPersonal.fk_idPersonal = id_personal
      this.activeStepButtonHandler()
    },

    async handleFetchArmasPersonal() {
      const CANTIDAD_ARMAS_PERMITIDAS = this.susceptibleTercerArma ? 3 : 2

      try {
        this.loading = true
        await this.fetchArmasPersonal(this.armaPersonal.fk_idPersonal)

        if (this.armasPersonal.length < CANTIDAD_ARMAS_PERMITIDAS) {
          this.activeStep++
        } else {
          this.SET_SNACKBAR_MESSAGE(
            `El elemento seleccionado ya cuenta con ${CANTIDAD_ARMAS_PERMITIDAS} armas asignadas.`
          )
        }
      } catch {
        this.SET_SNACKBAR_MESSAGE(`No fue posible obtener las armas asignadas al elemento.`)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
